import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./_store/store";
import BootstrapVue from "bootstrap-vue";

// // eslint-disable-next-line
// import './design/assets/scss/app.scss';

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
